export default "__VITE_ASSET__DTSMs5pL__"